export const SIGNIN_OIDC = '/signin-oidc'
export const SIGNOUT = '/signout'

export const INTRAY = '/InTray'
export const IMAGE = '/Image'

export const GROUP_UPDATE = {
  EDIT: '/qupid',
  LOG: '/qupid-log'
}

export const RECORD = {
  EDIT: '/accounts/:accountId/projects/:projectId/:moduleName/record/:recordId/edit'
}

export const RECORD_V2 = {
  EDIT: '/accounts/:accountId/projects/:projectId/:moduleName/record-v2/:recordId/edit'
}

export const RECORDS_SUMMARY = {
  LIST: '/records-summary'
}

export const REFERENCEITEMS = {
  LIST: '/referenceitems',
  REGISTER: '/referenceitems/register',
  EDIT: '/referenceitems/:referenceItemId',
  GROUPS:
    '/accounts/:accountId/projects/:projectId/:moduleName/referencegroups',
  MEMBERSHIPS:
    '/accounts/:accountId/projects/:projectId/:moduleName/referenceitems'
}

export const CERTIFICATES = {
  LIST: '/certs',
  REGISTER: '/certs/register',
  EDIT: '/certs/:certificateId'
}

export const COMPANIES = {
  LIST: '/companies',
  LIST_V2: '/companies_v2',
  EDIT: '/companies/:companyId',
  NEW: '/companies/new'
}

export const USERS = {
  LIST: '/users',
  EDIT: '/users/:userId',
  NEW: '/users/new'
}

export const ACCOUNTS = {
  LIST: '/accounts',
  EDIT: '/accounts/:accountId',
  NEW: '/accounts/new'
}

export const PROJECTS = {
  LIST: '/accounts/:accountId/projects',
  EDIT: '/accounts/:accountId/projects/:projectId',
  NEW: '/accounts/:accountId/projects/new'
}

export const NOTIFICATIONS = {
  LIST: '/accounts/:accountId/projects/:projectId/notifications',
  EDIT: '/accounts/:accountId/projects/:projectId/notifications/:notificationId',
  NEW: '/accounts/:accountId/projects/:projectId/notifications/register'
}

export const CONNECTIONS = {
  LIST: '/accounts/:accountId/projects/:projectId/connections',
  EDIT: '/accounts/:accountId/projects/:projectId/connections/:connectionId',
  NEW: '/accounts/:accountId/projects/:projectId/connections/register'
}

export const REFERENCE_DATA = {
  INDEX: '/reference-data'
}

export const PUBLIC_API_KEYS = {
  LIST: '/public-api-keys',
  EDIT: '/public-api-keys/:apiKeyId'
}

export const TEMPLATE_GUI = {
  INDEX: '/templates'
}

export const BI_REPORTS = {
  INDEX: '/biReports',
  EDIT: '/biReports/accounts/:accountId'
}

export const SMART_WASTE = {
  EDIT: '/accounts/:accountId/projects/:projectId/smartwaste'
}

export const ONECLICK_LCA = {
  EDIT: '/accounts/:accountId/oneclicklca'
}

export const PROCORE = {
  EDIT: '/accounts/:accountId/procore'
}

export const DEVELOPMENT = {
  PLAYGROUND: '/development/playground'
}
